const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cdp.mergetime.pt:5285';

export default API_BASE_URL;
